import type { ButtonProps } from '@mui/material';
import { Button, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import type { FC, ReactElement } from 'react';

interface SimpleButtonI {
  label: string;
  size: 'small' | 'medium' | 'large';
  onClick: (values: unknown) => void;
  icon?: ReactElement;
  secondary?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
  disabled?: boolean;
  loading?: boolean;
  color?: 'primary' | 'grass' | 'secondary' | string;
  labelColor?: string;
  fullWidth?: boolean;
  id?: string;
}

const SimpleButton: FC<SimpleButtonI> = ({
  label,
  size,
  onClick,
  icon,
  variant = 'contained',
  disabled = false,
  loading,
  color,
  labelColor,
  fullWidth,
  id,
}): JSX.Element => {
  const resolveColorProps = (): ButtonProps => {
    const props: ButtonProps = { sx: { textTransform: 'none' } };

    props.sx = {
      ...props.sx,
      backgroundColor: color,
      color: '#72CF76',
      '&:hover': {
        backgroundColor: color,
      },
    };

    return props;
  };

  return (
    <Button
      id={id}
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      endIcon={!loading ? icon : <CircularProgress color="inherit" size={20} />}
      {...resolveColorProps()}
    >
      <Typography
        sx={{
          color: labelColor,
          fontWeight: 'bolder',
        }}
      >
        {label}
      </Typography>
    </Button>
  );
};

export default SimpleButton;
